import { SweetAlertCustomClass } from 'sweetalert2';

export const SwalDesktopClasses: SweetAlertCustomClass = {
  popup: 'swal-large-font'
}

export const SwalMobileClasses: SweetAlertCustomClass = {
  popup: 'swal-large-font swal-mobile'
}
